// extracted by mini-css-extract-plugin
export default {"notesToUseContainer":"NotesToUse_notesToUseContainer__GHPBZ","notesToUseCheckboxes":"NotesToUse_notesToUseCheckboxes__bIfQW"};